<template>
  <div class="salesset" v-if="show">
    <el-row class="title">
      <el-col :span="24">
        <div>版本销售设置</div>
        <div>
          <el-row>
            <el-form label-width="80px">
              <el-col :span="6" class="content">
                <el-form-item label="版本类型">
                  <el-input value="绘图版" disabled></el-input>
                </el-form-item>
                <el-form-item label="基础价格">
                  <el-input v-model="list[0].basic_amount"></el-input>
                </el-form-item>
                <el-form-item label="账号数量">
                  <el-input value="1" disabled></el-input>
                </el-form-item>
                <el-form-item label="续费时长">
                  <el-input value="1年" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <div class="midle">
      <div>在线首购设置</div>
      <el-upload
        class="avatar-uploader"
        :action="picupload"
        :show-file-list="false"
        :on-success="handleAvatarSuccess"
      >
        <img v-if="imageUrl" :src="imageUrl" class="avatar" />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <el-row>
        <el-col :span="8">
          <div class="content">
            <div>1号位设置</div>
            <el-form label-width="80px">
              <el-form-item label="续费时长">
                <el-select v-model="list[1].time_value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="折扣">
                <el-input v-model="list[1].discount"></el-input>
              </el-form-item>
              <el-form-item label="折扣提示">
                <el-input v-model="list[1].discount_tips"></el-input>
              </el-form-item>
              <el-form-item label="英文提示">
                <el-input v-model="list[1].discount_tips_en"></el-input>
              </el-form-item>
              <el-form-item label="截止时间">
                <el-date-picker
                  v-model="list[1].expiration_time"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="content">
            <div>2号位设置</div>
            <el-form label-width="80px">
              <el-form-item label="续费时长">
                <el-select v-model="list[2].time_value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="折扣">
                <el-input v-model="list[2].discount"></el-input>
              </el-form-item>
              <el-form-item label="折扣提示">
                <el-input v-model="list[2].discount_tips"></el-input>
              </el-form-item>
              <el-form-item label="英文提示">
                <el-input v-model="list[2].discount_tips_en"></el-input>
              </el-form-item>
              <el-form-item label="截止时间">
                <el-date-picker
                  v-model="list[2].expiration_time"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="content">
            <div>3号位设置</div>
            <el-form label-width="80px">
              <el-form-item label="续费时长">
                <el-select v-model="list[3].time_value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="折扣">
                <el-input v-model="list[3].discount"></el-input>
              </el-form-item>
              <el-form-item label="折扣提示">
                <el-input v-model="list[3].discount_tips"></el-input>
              </el-form-item>
              <el-form-item label="英文提示">
                <el-input v-model="list[3].discount_tips_en"></el-input>
              </el-form-item>
              <el-form-item label="截止时间">
                <el-date-picker
                  v-model="list[3].expiration_time"
                  type="datetime"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                ></el-date-picker>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="midle foot">
      <div>在线续费设置</div>
      <el-row>
        <el-col :span="8">
          <div class="content">
            <div>1号位设置</div>
            <el-form label-width="80px">
              <el-form-item label="续费时长">
                <el-select v-model="list[4].time_value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="折扣">
                <el-input v-model="list[4].discount"></el-input>
              </el-form-item>
              <el-form-item label="折扣提示">
                <el-input v-model="list[4].discount_tips"></el-input>
              </el-form-item>
              <el-form-item label="英文提示">
                <el-input v-model="list[4].discount_tips_en"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="content">
            <div>2号位设置</div>
            <el-form label-width="80px">
              <el-form-item label="续费时长">
                <el-select v-model="list[5].time_value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="折扣">
                <el-input v-model="list[5].discount"></el-input>
              </el-form-item>
              <el-form-item label="折扣提示">
                <el-input v-model="list[5].discount_tips"></el-input>
              </el-form-item>
              <el-form-item label="英文提示">
                <el-input v-model="list[5].discount_tips_en"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="content">
            <div>3号位设置</div>
            <el-form label-width="80px">
              <el-form-item label="续费时长">
                <el-select v-model="list[6].time_value" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="折扣">
                <el-input v-model="list[6].discount"></el-input>
              </el-form-item>
              <el-form-item label="折扣提示">
                <el-input v-model="list[6].discount_tips"></el-input>
              </el-form-item>
              <el-form-item label="英文提示">
                <el-input v-model="list[6].discount_tips_en"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="btnrow">
      <el-button type="warning" @click="canceledit">取消修改</el-button>
      <el-button type="primary" @click="submitedit">确定修改</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    show: false,
    imageUrl: "",
    picupload: "",
    options: [
      {
        value: 1,
        label: "1年"
      },
      {
        value: 2,
        label: "2年"
      },
      {
        value: 3,
        label: "3年"
      },
      {
        value: 5,
        label: "5年"
      },
      {
        value: 8,
        label: "8年"
      },
      {
        value: 10,
        label: "10年"
      }
    ],
    list: [],
    backlist: []
  }),
  methods: {
    canceledit() {
      this.$set(this, "list", this.backlist);
    },
    submitedit() {
      this.$axios.put("price-configs", this.list).then(res => {
        this.$message({
          message: res.message,
          type: "success"
        });
      });
    },
    getdata() {
      this.$axios.get("price-config").then(res => {
        if (res.code == 1) {
          this.$set(this, "list", res.data);
          this.show = true;
          this.$set(this, "backlist", res.data);
        }
      });
    },
    handleAvatarSuccess(res, file) {
      if (res.code == 1) {
        this.imageUrl = res.data[0];
        this.$axios.put("banner", { banner_url: this.imageUrl }).then(res => {
          this.$message({
            message: res.message,
            type: "success"
          });
        });
      }
    },
    getbanner() {
      this.$axios.get("banner").then(res => {
        this.$set(this, "imageUrl", res.data);
      });
    }
  },
  mounted() {
    this.picupload = `${process.env.VUE_APP_BASEURL}uploads`;
    this.getdata();
    this.getbanner();
  }
};
</script>

<style lang="scss" scoped>
.salesset {
  .title {
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 4px;
    .content {
      padding: 4px;
      background: #bce2f4;
      border-radius: 4px;
    }
  }
  .midle {
    border: 1px solid #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 4px;
    .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
    .content {
      margin: 10px;
      background: #bce2f4;
      text-align: center;
    }
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  .btnrow {
    margin-top: 30px;
    height: 200px;
    text-align: right;
  }
}
</style>